import { createFlightsSummaryActions } from './checkoutFlightSummaryActions';
export const flightSummaryActions = createFlightsSummaryActions(window.Odigeo);